import type { PostFullRegisterRequest } from './types';
import type { GetFullRegisterResponse } from '../get';

import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

export const postFullRegister = async ({ data, lang, token }: PostGenericEndpointParams<PostFullRegisterRequest>): Promise<GetFullRegisterResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: 'register/full',
    });
};
